import { render, staticRenderFns } from "./AdminAutoLogin.vue?vue&type=template&id=63940d27&scoped=true"
import script from "./AdminAutoLogin.vue?vue&type=script&lang=js"
export * from "./AdminAutoLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminAutoLogin.vue?vue&type=style&index=0&id=63940d27&prod&scoped=true&lang=css"
import style1 from "@/assets/css/authen.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/newLogin.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63940d27",
  null
  
)

export default component.exports